import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDefaultBg = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 320,
	height: 64,
	viewBox: "0 0 320 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 32C0 16.9151 0 9.37258 4.68629 4.68629C9.37258 0 16.9151 0 32 0H288C303.085 0 310.627 0 315.314 4.68629C320 9.37258 320 16.9151 320 32C320 47.0849 320 54.6274 315.314 59.3137C310.627 64 303.085 64 288 64H32C16.9151 64 9.37258 64 4.68629 59.3137C0 54.6274 0 47.0849 0 32Z",
		fill: "#282A33"
	})
});
export default SvgDefaultBg;
